"use strict";

// header 背景
$(function () {
    $(".header_gnav-item").mouseover(function () {
        $(".header_gnav-overlay").css("display", "block");
    });
    $(".header_gnav-item").mouseout(function () {
        $(".header_gnav-overlay").css("display", "none");
    });
});

// ドロワー_開閉ボタン
$(function () {
    $(".block_drawer-toggle--button").on("click", function () {
        if ($(this).hasClass("active") != true) {
            $(".block_itemList-sort").removeClass("open");
            $(this).addClass("active");
            $(".for_sp").addClass("open");
            if ($(".block_drawer_overlay").css("display") != "block") {
                $(".block_drawer_overlay").fadeIn();
            } else {
            }
        } else {
            $(this).removeClass("active");
            $(".for_sp").removeClass("open");
            $(".block_drawer_overlay").fadeOut();
        }
    });
});
$(function () {
    $(".block_drawer_overlay").on("click", function () {
        $(".for_sp").removeClass("open");
        $(".block_drawer_overlay").fadeOut();
        $(".block_drawer-toggle--button").removeClass("active");
    });
});
$(function () {
    $("details").on("click", function () {
        $(this).toggleClass("open");
    });
});

// ヘッダーの固定（スクロール保存）
if (window.matchMedia("(max-width:768px)").matches) {
    function bodyFixed() {
        //変数の設定
        var body = $("body");
        var header_spNav = $(".header_spnav");

        //スクロール量を保存
        var scrollTop;
        var isFixed = false;
        //スクロールを固定
        function bodyFixedOn() {
            if (!isFixed) {
                scrollTop = $(window).scrollTop();

                body.css({
                    position: "fixed",
                    top: -scrollTop
                });
                header_spNav.css({
                    position: "fixed",
                    top: 0,
                    height: "60px"
                });
                isFixed = true;
            }
        }
        //スクロールの固定を解除
        function bodyFixedOff() {
            if (isFixed) {
                body.css({
                    position: "",
                    top: ""
                });
                header_spNav.css({
                    position: "",
                    top: "",
                    height: ""
                });
                $(window).scrollTop(scrollTop);
                isFixed = false;
            }
        }

        //モーダルのトリガーをクリックしたとき
        $(".block_drawer-toggle--button").on("click", function () {
            if (isFixed) {
                bodyFixedOff();
            } else {
                bodyFixedOn();
            }
        });
        $(".block_drawer_overlay").on("click", function () {
            if (isFixed) {
                bodyFixedOff();
            } else {
                bodyFixedOn();
            }
        });
    }
    bodyFixed();
}

// // ドロワー_検索フォーム
// $(function () {
//     $(".search_drawer").on("click", function () {
//         $(".for_sp").removeClass("open");
//         $(".block_itemList-sort").removeClass("open");
//         $(".block_drawer-toggle--button").removeClass("active");
//         $(".block_search_drawer").addClass("open");
//         $(".block_drawer_overlay").fadeIn();
//     });
//     $(".block_search_button").on("click", function () {
//         $(".block_search_drawer").removeClass("open");
//         $("body").removeClass("fixed");
//         $(".header_spnav").removeClass("fixed");
//         $(".block_drawer_overlay").fadeOut();
//     });
// });

// ドロワー_絞り込み検索
$(function () {
    $(".drawer-filter").on("click", function () {
        $(".block_drawer-toggle--button").removeClass("active");
        $(".block_itemList-sort").addClass("open");
        $(".block_drawer_overlay").fadeIn();
    });
    $(".drawer-filter-close").on("click", function () {
        $(".block_itemList-sort").removeClass("open");
        $("body").removeClass("fixed");
        $(".header_spnav").removeClass("fixed");
        $(".block_drawer_overlay").fadeOut();
    });
});

// アコーディオン
$(function () {
    $(".accordion_toggle").on("click", function () {
        $(this).toggleClass("open");
        $(this).next().slideToggle(200);
    });
});

// swiper TOP
const swiper = new Swiper(".swiper-hero", {
    // Optional parameters
    direction: "horizontal",
    loop: true,

    // If we need pagination
    pagination: {
        el: ".swiper-pagination"
    },

    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },

    autoplay: {
        delay: 5000
    }
});
// swiper nav1
var swiperNav = new Swiper(".swiper-nav", {
    // Optional parameters
    direction: "horizontal",
    loop: true,
    autoplay: {
        delay: 3000
    }
});

// swiper blog
var swiperBlog = new Swiper(".swiper-blog", {
    // Optional parameters
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,

    // If we need pagination
    pagination: {
        el: ".swiper-pagination"
    },

    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    breakpoints: {
        576: {
            slidesPerView: 4,
            loop: false
        }
    }
});

// swiper scroll
var swiperScroll = new Swiper("#scroll1", {
    centeredSlides: false,
    slidesPerGroupSkip: 1,
    grabCursor: true,
    slidesPerView: 2.2,
    breakpoints: {
        576: {
            slidesPerView: 4.6
        }
    },

    scrollbar: {
        el: ".swiper-scrollbar"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});

var swiperScroll = new Swiper("#scroll2", {
    centeredSlides: false,
    slidesPerGroupSkip: 1,
    grabCursor: true,
    slidesPerView: 2.2,
    breakpoints: {
        576: {
            slidesPerView: 4.5
        }
    },
    scrollbar: {
        el: ".swiper-scrollbar"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});

var swiperScroll = new Swiper("#scroll3", {
    centeredSlides: false,
    slidesPerGroupSkip: 1,
    grabCursor: true,
    slidesPerView: 2.2,
    breakpoints: {
        576: {
            slidesPerView: 4.5
        }
    },

    scrollbar: {
        el: ".swiper-scrollbar"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});
var swiperScroll = new Swiper("#scrollProduct", {
    centeredSlides: false,
    slidesPerGroupSkip: 1,
    grabCursor: true,
    slidesPerView: 3.5,
    breakpoints: {
        576: {
            slidesPerView: 5
        }
    },

    scrollbar: {
        el: ".swiper-scrollbar"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});

var swiperScroll = new Swiper("#scrollRecommend", {
    centeredSlides: false,
    slidesPerGroupSkip: 1,
    grabCursor: true,
    slidesPerView: 3.5,
    breakpoints: {
        576: {
            slidesPerView: 5
        }
    },

    scrollbar: {
        el: ".swiper-scrollbar"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});

// swiper_product
var swiperProductThumb = new Swiper(".swiper_product-thumb", {
    spaceBetween: 10,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true
});
var swiperProduct = new Swiper(".swiper_product-main", {
    spaceBetween: 10,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    thumbs: {
        swiper: swiperProductThumb
    },
    scrollbar: {
        el: ".swiper-scrollbar"
    }
});

// thumbnails

$(document).on("click", ".changeThumb", function () {
    // クリックしたミニサムネイルのソースを取得
    let imageSrc = $(this).attr("src");
    // ディスプレイ画像を取得
    let mainThumb = $(this)
        .closest(".block_card-thumbnail")
        .prev()
        .find(".main-thumb");

    // クリックしたサムネイルが何番目かを取得
    let indexNum = $(this).parent().index();
    // 商品タイトルを取得
    let productTitle = $(this)
        .closest(".block_card-thumbnail")
        .next()
        .find(".block_card-text--title a")
        .attr("href")
        .split("/")
        .pop()
        .replace(/-/g, "_");
    productTitle = productTitle.split("?")[0];
    // メインサムネイルのソースを書き換え
    $(mainThumb).attr("src", imageSrc);

    // 商品タイトルと変数”jsPrice”を結合
    let selectPrice = eval("jsPrice" + productTitle);
    let selectBasePrice = eval("basePrice" + productTitle);
    let selectSoldOutPrice = eval("soldOutPrice" + productTitle);
    // 商品の値段を取得
    // 今の売値
    let getPrice = $(this)
        .closest(".block_card-thumbnail")
        .next()
        .find(".block_card-text--price .price-item.price-item--regular");

    // 売り切れ商品
    let getSoldOutPrice = $(this)
        .closest(".block_card-thumbnail")
        .next()
        .find(
            ".block_card-text--price .price--sold-out .price-item.price-item--regular"
        );

    // セール品の割引前料金
    let getBasePrice = $(this)
        .closest(".block_card-thumbnail")
        .next()
        .find(
            ".block_card-text--price .price__sale .price-item.price-item--regular"
        );
    // セール品の売値
    let getSalesPrice = $(this)
        .closest(".block_card-thumbnail")
        .next()
        .find(
            ".block_card-text--price .price__sale .price-item.price-item--sale.price-item--last"
        );

    // 要素から金額を入手
    let setPrice = (selectPrice[indexNum] / 100).toLocaleString();
    let setBasePrice = (selectBasePrice[indexNum] / 100).toLocaleString();
    let setSoldOutPrice = (selectSoldOutPrice[indexNum] / 100).toLocaleString();

    // // ページがbindingを含むURLかどうかをチェック
    if (window.location.href.includes("binding")) {
        $(getPrice).text("¥" + setPrice);
        $(getSalesPrice).text("¥" + setPrice);
        $(getBasePrice).text("¥" + setBasePrice + " ");
        if (selectPrice.length === 0 && selectBasePrice.length === 0) {
            $(getSoldOutPrice).text("¥" + setSoldOutPrice);
        }
    }
});

$(function () {
    if (window.matchMedia("(min-width:991px)").matches) {
        $(".pc-hidden").remove();
    } else {
        $(".pc-hidden").append();
    }
});

$(function () {
    let productThumb = $(
        ".block_slider-addthumb .swiper_product-main .swiper-slide:first-child img"
    );
    let valueColor = $("#label_COLOR input[checked]").attr("value");
    let valueSize = $("#label_SIZE input[checked]").attr("value");
    let labelColor = $("#label_COLOR .form__label-value");
    let labelSize = $("#label_SIZE .form__label-value");
    labelColor = labelColor.text(valueColor);
    labelSize = labelSize.text(valueSize);
    $(".product-form__input#label_COLOR input").on("click", function () {
        let srcColor = $(this)
            .next()
            .find(".product_selectImg img")
            .attr("src");
        valueColor = $(this).attr("value");
        labelColor = labelColor.text(valueColor);
        $(productThumb).attr("src", srcColor);
    });
    $(".product-form__input#label_SIZE input").on("click", function () {
        valueSize = $(this).attr("value");
        labelSize = labelSize.text(valueSize);
    });
});

// 商品の売り切れ表示
//=============================
if (window.location.pathname.includes("/products/")) {
    const stockTarget = document.querySelector(".stock-target");
    let changeValue = document.querySelector(".product_ableText").innerHTML;
    // コールバック関数
    const callback = (mutations) => {
        mutations.forEach((mutation) => {
            changeValue = document.querySelector(".product_ableText").innerHTML;
            if (changeValue == "利用できません") {
                stockTarget.classList.add("product_unable");
            } else {
                stockTarget.classList.remove("product_unable");
            }
        });
    };
    // コールバック関数の受け渡し＆オブザーバー生成
    const stockObserver = new MutationObserver(callback);

    const config = {
        childList: true,
        characterData: true,
        subtree: true
    };

    stockObserver.observe(stockTarget, config);

    // 関数内でsizeInputを再定義
    function updateProductClasses() {
        let sizeInput = $(".product-form__input#label_SIZE input"); // sizeInputをここで再定義

        // 選択された色オプションの値を取得
        let colorKey = $(
            ".product-form__input#label_COLOR input:checked"
        ).val();

        // 選択された色に一致する商品を取得
        let selectedProducts = productData.filter(
            (product) => product.colorKey === colorKey
        );

        if (selectedProducts.length > 0) {
            // 選択された色に一致する商品が見つかった場合
            selectedProducts.forEach((product) => {
                let sizeKey = product.sizeKey;
                let variantStock = product.availableKey;

                // クラスを制御
                sizeInput.each(function () {
                    let sizeInputValue = $(this).val();
                    if (sizeInputValue === sizeKey) {
                        if (variantStock === false) {
                            $(this).addClass("out_of_stock");
                        } else {
                            $(this).removeClass("out_of_stock");
                        }
                    }
                });
            });
        }
    }

    // ページ読み込み時とクリック時に関数を実行
    $(document).ready(function () {
        updateProductClasses();
    });

    $(".product-form__input#label_COLOR input").on("click", function () {
        updateProductClasses();
    });
}

// header スクロール時に固定表示
//=========================

// 各エレメント取得
const header = document.getElementById("header");
const mainContent = document.getElementById("MainContent");

const announcementBar = document.querySelector(".announcement-bar");
const sticky = announcementBar.offsetHeight;

function handleScroll() {
    if (window.pageYOffset > sticky) {
        header.style.position = "fixed";
        header.style.top = "0";
		mainContent.style.marginTop = "60px";
    } else {
        header.style.position = "relative";
        header.style.top = "auto";
		mainContent.style.marginTop = "0";
    }
}

window.onscroll = () => handleScroll();
